var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"brand-style-2"},_vm._l((_vm.brandImages),function(brand,i){return _c('li',{key:i},[_c('a',{attrs:{"href":brand.url}},[_c('img',{attrs:{"src":brand.src,"alt":"Logo Images"}})])])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }